import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ModalBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CloseIcon } from 'assets/icon-close-round.svg';
import { ModalHeader } from 'shared/components/modal/ModalHeaders';
import { Modal } from 'shared/components/modal/Modals';
import { colors } from 'shared/defaultTheme';

const CloseComponentWrapper = styled.button`
  background-color: transparent;
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 21px;
  width: 112px;
  padding: 0;

  &:active {
    opacity: 0.5;
  }

  span {
    color: ${colors.blueLefebvre};
    font-size: 12px;
    line-height: 21px;
    margin-top: 3px;
  }

  svg {
    fill: ${colors.blueLefebvre};
    height: 14px;
    width: 14px;
  }
`;

const ModalPreview = ({ isOpen, children, toggle }) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader
        className="general-customizer__modal-header-preview"
        backgroundColor={colors.transparent}
        closeComponent={
          <CloseComponentWrapper onClick={toggle}>
            <span className="form__label">{t('general_close_preview')}</span>
            <CloseIcon />
          </CloseComponentWrapper>
        }
        onClose={toggle}
      />
      <ModalBody>{children}</ModalBody>
    </Modal>
  );
};

ModalPreview.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  toggle: PropTypes.func.isRequired,
};

export default ModalPreview;
